// mainnet
export const NftContractAddress = "0x0Fbf892788A3737d6d0914F5E7E1882015BeC0DC"
export const StakingContractAddress = "0x5EEbb475c95716441123C9f7dfFbD5D6A203471F"
export const chainId = 1
// goerli
// export const NftContractAddress = "0x476e4Fb1d5BfCB760933C4C80411b5152e201D87"
// export const StakingContractAddress = "0x06aD79b8EeEDA7A58cD30350cB9a57067ef007bF"
// export const chainId = 5

export const infura = "6de59dc14a914133b494e6208a6b914f";